const SESSION = {
    SESSION: {
        url: '/session',
        queryKey: 'getSession'
    },
    ASSETS: {
        url: '/assets',
        queryKey: 'getAssets'
    },
    FETCH_MFA_ACTIVATION: {
        url: '/getMfaExistence',
        queryKey: '/queryGetMfa'
    },
    FETCH_QRCODE_URI: {
        url: '/generateMfaUri',
        queryKey: 'queryQrcodeUri'
    },
    INITIALIZE_MFA: {
        url: '/initializeMfa'
    },
    SEND_MFA_DEACTIVATION_MAIL: {
        url: '/sendMfaDeactivationMail'
    },
    MFA_DEACTIVATION_CONFIRMATION: {
        url: '/mfaDeactivationConfirmation'
    },
    DEACTIVATE_MFA_AT_LOGIN: {
        url: '/deactivateMfaAtLogin'
    },
    INDEX_HTML: {
        queryKey: 'getLastBuildData',
        url: '/index.html'
    }
};

export default SESSION;